import { createFileRoute } from '@tanstack/react-router'

import { HealthInsurancePageSkeleton } from '#/modules/health/front-office/health-insurance-page/health-insurance-page-skeleton.tsx'
import { HealthInsurancePage } from '#/modules/health/front-office/health-insurance-page/health-insurance-page.tsx'

export const Route = createFileRoute('/(customer)/_shell/health-insurance-v2/')({
  loader: ({ context }) => context.queryClient.ensureQueryData(context.trpc.contracts.listMyContracts.queryOptions()),
  pendingComponent: HealthInsurancePageSkeleton,
  pendingMs: 150,
  component: HealthInsurancePage,
})
